import { createRoutine } from 'redux-saga-routines';
import * as types from 'legacy/src/constants/types';

function logoutSuccess() {
  return { type: types.LOGOUT_SUCCESS };
}

export function savePreferenceSuccess(payload) {
  return {
    type: types.SAVE_PREFERENCE_SUCCESS,
    payload,
  };
}

export const levityLoginAction = createRoutine('LEVITY_LOGIN');
export const levityLogoutAction = createRoutine('LEVITY_LOGOUT');
export const bindLevityEventsAction = createRoutine('BIND_LEVITY_EVENTS');
export const storeCbSessionAction = createRoutine('STORE_CB_SESSION');
export const authenticateStrategyAction = createRoutine(
  'AUTHENTICATE_STRATEGY',
);
export const navigateToError = createRoutine('NAVIGATE_TO_ERROR');
export const redirectToHomeAction = createRoutine('REDIRECT_TO_HOME');
export const redirectToROSLoginAction = createRoutine('REDIRECT_TO_ROS_LOGIN');
export const redirectToLoginAction = createRoutine('REDIRECT_TO_LOGIN');
export const authorize = createRoutine('AUTHORIZE');
export const login = createRoutine('LOGIN');
export const storeApolloClientAction = createRoutine('STORE_APOLLO_CLIENT');

export function addSession(payload) {
  return (dispatch) => {
    dispatch(authorize.success(payload));
  };
}

export function endSession() {
  return (dispatch) => {
    dispatch(logoutSuccess());
  };
}
